<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { shendure } from 'src/services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Text, Button, Alert, toast } from '@Shelly/shelly-design-system';

	import { deleteDevice } from 'src/helpers/add_delete_helpers';
	import { save_home } from 'src/helpers/home_helpers';

	let loading = false;

	const handleDelete = async () => {
		loading = true;
		try {
			let res = await shendure.get(`remove_user`);
			if (res?.data?.isok) {
				for (let index = 0; index < Object.values($devices).length; index++) {
					const element = Object.values($devices)[index];
					if (element.gen === 'GXP') await deleteDevice(element.id);
				}
			}

			save_home('zendure', {
				user: null,
				uid: null,
			});

			toast.open({
				type: 'success',
				title: $format('success_remove_zendure_user', {
					default: 'Zendure user successfully removed.',
				}),
			});
		} catch (erorr) {
			toast.open({
				type: 'danger',
				title: $format('failed_to_remove_zendure_user', {
					default: 'Failed to remove zendure user.',
				}),
			});
		}
		loading = false;
	};
</script>

<div class="d-flex justify-content-center align-items-center mb-s">
	<Text element="h1" class="mb-s">
		{$format('text_zendure_account_management', {
			default: 'Zendure Account Management',
		})}
	</Text>
</div>

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={$format('alert_heading_zendure_remove_user', {
		default:
			'Removing Zendure integration will delete all associated Zendure devices from your account',
	})}
/>
<Button width="l" {loading} variant="danger" on:click={handleDelete}
	>{$format('button_remove_zendure_integration', {
		default: 'Remove Integration',
	})}</Button
>
